import React from 'react';

import {observer} from 'mobx-react';
import {BaseProps} from "../../../../../infrastructure/models/props/base-props";
import styles from "./game-card-odds-cell.module.scss";
import classNames from "classnames";
import {OddsCellViewModel} from "../../../../../domain/common/odds-preview/models/odds-cell/odds-cell.view-model";
import {Ellipsis} from "../../../misc/ellipsis/ellipsis";
import {useBookieClick} from "../../../../../infrastructure/hooks/useBookieClick";
import {APP} from "../../../../app/consts";
import {PartialGameViewModel} from "../../../../../domain/partial-game/models/partial-game-view-model";
import {ALL_SCORES} from "../../../../../widgets/all-scores-widget/all-scores-widget-consts";
import {LINK_REL} from "../../../../consts";
import {Link} from "../../../link/link";

export class GameCardOddsCellUsLayoutProps extends BaseProps {
  cell: OddsCellViewModel;
  cellClassName: String;
}

export const GameCardOddsCellUsLayout = observer(({
                                                    cell,
                                                    game,
                                                    controller,
                                                    source,
                                                    currentLinkModel,
                                                    appSettings,
                                                    cellClassName,
                                                  }: GameCardOddsCellUsLayoutProps) => {
  const {isBold, text} = cell;
  const {odds} = game;


  const {bookieHrefModel, onBookieClick} = useBookieClick(controller, {
    urlLink: appSettings.publisherSettings?.bookmakerUrl || odds?.bookmaker.link,
    entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[PartialGameViewModel.name],
    entityId: game.id,
    status: game.statusGroup,
    currentLinkModelName: currentLinkModel?.name,
    marketType: odds?.lineTypeId,
    bookieId: odds?.bookmaker.id,
    bookieName: odds?.bookmaker.name,
    clickType: ALL_SCORES.ANALYTICS.BOOKIE_CLICK_TYPES.bookie,
    impressionType: APP.ANALYTICS.BETS_IMPRESSION_TYPES.odds,
    hasOdds: true,
    source
  });

  const canClickBookie = !!(bookieHrefModel && onBookieClick) && !odds?.bookmaker?.isDummyBookie;

  const linkProps = {
    model: bookieHrefModel,
    rel: LINK_REL.SPONSORED_NOOPENER,
    onClick: canClickBookie ? (e) => {
      e.stopPropagation();

      return onBookieClick();
    } : undefined,
    className: classNames(styles.container, cellClassName, styles.us_layout)
  }

  return <Link {...linkProps}>
    <Ellipsis className={classNames(styles.text, {[styles.cell_ended]: !isBold})}>{text}</Ellipsis>
  </Link>
});
